










import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import * as service from '../../subjects/loader';

@Component
export default class UiLoader extends Vue {
  public loading: boolean = false;
  public message: string = '';

  public beforeMount(): void {
    service.get().subscribe((data) => {
      this.loading = data.status;
      this.message = data.message;
    });
  }
}
